import React, { useContext } from "react";
import { useLocation, useParams } from "react-router";
import { AppContext } from "../../contexts/app-context";

export function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function useAppInfoFromUralParams() {
    const { appId, intent } = useParams();
    return { appId, intent };
}

export function useAppContext() {
    return useContext(AppContext);
}

export function useAppInfo() {
    const context= useContext(AppContext);
    return context.appInfo;
}
